import { render, staticRenderFns } from "./CommonSwiper.vue?vue&type=template&id=89134eda&scoped=true&"
import script from "./CommonSwiper.vue?vue&type=script&lang=js&"
export * from "./CommonSwiper.vue?vue&type=script&lang=js&"
import style0 from "swiper/dist/css/swiper.css?vue&type=style&index=0&lang=css&"
import style1 from "./CommonSwiper.vue?vue&type=style&index=1&id=89134eda&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89134eda",
  null
  
)

export default component.exports